import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';

const LayoutSimple = ({ children }) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50">
      {/* Header */}
      <motion.header
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        className="bg-white/80 backdrop-blur-xl border-b border-gray-200/50 sticky top-0 z-50"
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <Link
              to="/login"
              className="flex items-center space-x-3 text-slate-700 hover:text-blue-600 transition-colors group"
            >
              <motion.div
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="flex items-center space-x-2"
              >
                <ArrowLeftIcon className="h-5 w-5" />
                <span className="font-semibold">Back to Login</span>
              </motion.div>
            </Link>

            <div className="flex items-center space-x-4">
              <Link
                to="/terms"
                className="text-sm text-slate-600 hover:text-blue-600 transition-colors"
              >
                Terms
              </Link>
              <Link
                to="/privacy"
                className="text-sm text-slate-600 hover:text-blue-600 transition-colors"
              >
                Privacy
              </Link>
              <Link
                to="/refund"
                className="text-sm text-slate-600 hover:text-blue-600 transition-colors"
              >
                Refund
              </Link>
            </div>
          </div>
        </div>
      </motion.header>

      {/* Main Content */}
      <main className="flex-1">
        {children}
      </main>

      {/* Footer */}
      <footer className="bg-white/50 backdrop-blur-sm border-t border-gray-200/50 mt-auto">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <div className="text-center">
            <p className="text-sm text-slate-600">
              © {new Date().getFullYear()} Innovative CRM. All rights reserved.
            </p>
            <div className="flex justify-center space-x-6 mt-4">
              <Link to="/terms" className="text-xs text-slate-500 hover:text-blue-600 transition-colors">
                Terms of Service
              </Link>
              <Link to="/privacy" className="text-xs text-slate-500 hover:text-blue-600 transition-colors">
                Privacy Policy
              </Link>
              <Link to="/refund" className="text-xs text-slate-500 hover:text-blue-600 transition-colors">
                Refund Policy
              </Link>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default LayoutSimple;